import { useEffect } from "react";
import { siteSettings } from "../settings";

function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function SiteHead() {
  useEffect(() => {
    const ogTitle = `${siteSettings.name} - ${siteSettings.tagline}`;
    const ogImageUrl = new URL(siteSettings.ogImage, siteSettings.link).href;

    document.title = siteSettings.name;
    setMeta("name", "description", siteSettings.description);
    setMeta("property", "og:title", ogTitle);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", siteSettings.name);
    setMeta("property", "og:url", siteSettings.link);
    setMeta("property", "og:image", ogImageUrl);
    setMeta("property", "og:image:width", "1200");
    setMeta("property", "og:image:height", "630");
    setMeta("property", "og:image:type", "image/png");
  }, []);

  return null;
}
